'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ItemIndex = require('./components/ItemIndex.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemIndex).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/item-index/index.js
// module id = 1040
// module chunks = 0